import { connect } from 'react-redux';
import { exposActions } from '../../../../../redux/admin/expos/actions';
import EndExpo from './index';

const mapDispatchToProps = {
  endExpo: exposActions.endExpo,
};

export default connect(null, mapDispatchToProps)(EndExpo);
